
import AsyncStorage from '@react-native-async-storage/async-storage'
import React, { useEffect } from 'react'
import { View, useWindowDimensions, Platform } from 'react-native'
import constant from '../../../constant'
import Welcome from '../../../entry/welcome/index.web'
import { gradientBackground } from '../../../utils'
import { commonStyles } from '../../../utils/commonStyles'

export default function WelcomeContainer({ navigation }) {

    const dimensions = useWindowDimensions();
    const isLargeScreen = dimensions.width >= 768;

    useEffect(() => {

        if (Platform.OS == 'web') {
            AsyncStorage.getItem(constant.appKey.isVerifedUser).then(validUser => {
                if (validUser == "true") {
                    navigation.replace('WebDrawerNavigator')
                }
            });
        }
    }, [])


    return (
        <View style={commonStyles.mainContainer} key={'MainContainer'}>
            {gradientBackground()}
            <View style={commonStyles.webSubContainerStyle} key={'SubContainer'}>
                <View style={[commonStyles.webBorderViewStyle, { width: isLargeScreen ? '50%' : '90%', height: '60%' }]} key={'BorderView'}>
                    <View style={{ flex: 1 }}>
                        <Welcome props={navigation} />
                    </View>
                </View>
            </View>
        </View>
    )
}





